import BaseAPIService from '../base/base-api-service';
import TrackingModel from 'src/model/trackingInfo.model';
import DateRangeModel from 'src/model/dateRange.model';

interface ITrackFilters {
  dates: DateRangeModel | null;
  search: string;
  sortBy: string;
  sortIn: 'ASC' | 'DESC' | 'AUTO';
}

interface IPagination {
  pageNumber: number;
  totalPages: number;
  pageSize: number;
  totalElements: number;
}

class TrackingService extends BaseAPIService<TrackingModel> {
  constructor() {
    super(TrackingModel);
  }
  private endpoint: string = 'accountapp/v1/trackingInformation';

  private buildTrackingParams = (
    filters: ITrackFilters,
    pagination: IPagination
  ) => {
    const { dates, search, sortBy, sortIn } = filters;
    const parameters: any = {
      from:
        dates !== null && dates !== undefined && dates.start !== null
          ? dates.start.format('YYYY-MM-DD')
          : undefined,
      to:
        dates !== null && dates !== undefined && dates.end !== null
          ? dates.end.format('YYYY-MM-DD')
          : undefined,
      search: search ? search : undefined,
      sortBy: sortBy ? sortBy : undefined,
      sortIn: sortIn ? sortIn : undefined
    };
    Object.keys(parameters).forEach(key =>
      parameters[key] === undefined ? delete parameters[key] : ''
    );

    let queryParams = `page=${pagination.pageNumber}&size=${pagination.pageSize}&`;

    Object.keys(parameters).map((key, index) => {
      switch (key) {
        case 'from':
          queryParams += `dateFrom=${parameters[key]}&`;
          break;
        case 'to':
          queryParams += `dateTo=${parameters[key]}&`;
          break;
        case 'search':
          queryParams += `search=${parameters[key]}&`;
          break;
        case 'sortBy':
          queryParams += parameters.sortIn
            ? `sort=${
                parameters[key] === 'date' ? 'pickupDate' : parameters[key]
              },${parameters.sortIn}&`
            : '';

        default:
          break;
      }
    });
    return queryParams.slice(0, queryParams.length - 1);
  };

  private mapToModel = (data: any) => {
    const modelData = data.map((element: any) => {
      const {
        salesOrderNumber,
        pickupDate,
        confirmation,
        warehouse,
        courier,
        serviceType,
        trackingNumber,
        trackingLink
      } = element;
      return {
        orderNumber: salesOrderNumber,
        orderDate: pickupDate,
        confirmationNumber: confirmation,
        shippedFrom: warehouse,
        shippedMethod: `${courier} ${serviceType}`,
        trackNumber: trackingNumber,
        trackingLink: trackingLink ? trackingLink : null
      };
    });
    return modelData;
  };

  public getTracking(filters: ITrackFilters, pagination: IPagination) {
    const params = this.buildTrackingParams(filters, pagination);
    const trackingEndpoint = `${this.baseURL}${this.endpoint}?${params}`;

    return new Promise((resolve, reject) => {
      this.doRequest({
        method: 'get',
        url: trackingEndpoint
      })
        .then((response: any) => {
          const res = {
            ...response.data,
            data: this.mapToModel(response.data.data)
          };
          resolve(res);
        })
        .catch((error: any) => {
          console.log(error);
          reject(error);
        });
    });
  }
}
const TrackingServiceInstance = new TrackingService();
Object.freeze(TrackingServiceInstance);

export default TrackingServiceInstance;
